"use client";

import { FEATURE_FLAGS } from ".constants/featureFlags";
import { GTMEvent } from ".constants/gtmEvents";
import { FC, HTMLAttributes, useEffect, useState } from "react";

import { useHeadersContext } from "@/providers";
import { getIsPwa } from "@/utils/getIsPwa";

import { PwaButton } from "./PwaButton";

type PwaButtonWrapperProps = HTMLAttributes<HTMLDivElement> & {
  portalEvent: GTMEvent;
  promptEvent: GTMEvent;
};

export const PwaButtonWrapper: FC<PwaButtonWrapperProps> = ({
  children,
  promptEvent,
  portalEvent,
  ...props
}) => {
  const { ["user-agent"]: userAgent } = useHeadersContext();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDisabledPwa = /Firefox|XiaoMi|MiuiBrowser/i.test(userAgent);
    if (isDisabledPwa) {
      return setIsVisible(false);
    }

    const isPWA = getIsPwa();
    if (isPWA) {
      return setIsVisible(false);
    }

    setIsVisible(true);
  }, [userAgent]);

  if (!isVisible || !FEATURE_FLAGS.IS_PWA_ENABLED) {
    return null;
  }

  return (
    <PwaButton
      portalEvent={portalEvent}
      promptEvent={promptEvent}
      setIsVisible={setIsVisible}
      {...props}
    >
      {children}
    </PwaButton>
  );
};
